<template>
  <div
    class="switching-company"
    v-loading="true"
    element-loading-text="正在切换公司，请稍候..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.9)"
  >
    <div class="switching-company-main">
      <div class="title">正在切换公司</div>
      <div class="desc" v-if="companyName">即将进入：{{ companyName }}</div>
      <div class="desc" v-else>正在加载新公司数据，请勿操作...</div>
    </div>
  </div>
</template>

<script>
import { modules } from "../store";
import { mapActions } from "vuex";

export default {
  name: "SwitchingCompany",
  data() {
    return {
      companyName: "",
      switching: false
    };
  },
  methods: {
    ...mapActions(modules.account, ["changeCompany"]),
    async doSwitch() {
      if (this.switching) return;
      this.switching = true;

      const id = this.$route.query.id;
      this.companyName = this.$route.query.name || "";

      if (!id || id === "-2") {
        this.$router.replace({ path: "/" });
        return;
      }

      try {
        await this.changeCompany(id);
        // 整页跳转，确保菜单/权限/缓存均按新公司重新初始化
        window.location.replace("/");
      } catch (e) {
        this.$message.error("切换公司失败，请重试");
        this.$router.replace({ path: "/" });
      }
    }
  },
  mounted() {
    this.doSwitch();
  }
};
</script>

<style lang="stylus" scoped>
.switching-company
  background: #fff
  width: 100%
  height: 100vh
  position: relative

  .switching-company-main
    text-align: center
    position: absolute
    left: 50%
    top: 32%
    transform: translateX(-50%)
    z-index: 1

    .title
      font-size: 28px
      color: #3389ff
      margin-bottom: 12px

    .desc
      font-size: 16px
      color: #333
      font-family: MicrosoftYaHei
</style>
